import { combineReducers } from 'redux';
import signUp from './sign-up';

export const signUpReducers = combineReducers({
  signUp,
});
